import { z } from "zod";

import { CourseSchema } from "../courses/Course.schema";
import { CreatedAt, hexColorRegex, UpdatedAt } from "../shared/base";

import { PreferenceThemeSlugsEnum } from "./Preference.enums";

const ThemeSlugs = z.nativeEnum(PreferenceThemeSlugsEnum);

export const PreferenceSchema = z.object({
  uuid: z.string().uuid(),
  course: CourseSchema,
  themeSlug: ThemeSlugs,
  color: z.string().regex(hexColorRegex, "Hexadecimal invalido"),
  customized: z.boolean(),
  logo: z.string().nullable(),
  createdAt: CreatedAt,
  updatedAt: UpdatedAt,
});
